import React from 'react';

import { SortGameCommon } from 'components';

const SortGamePage = () => {
    return (<SortGameCommon />);
}

export default SortGamePage;
